export type TicketUnreadInvalidationReason = 'read' | 'closed'

export interface TicketUnreadInvalidation {
  type: 'ticket-unread-invalidated'
  userId: string
  ticketId: string
  reason: TicketUnreadInvalidationReason
}

const CHANNEL_NAME = 'ticket-unread-invalidated'

let activeUserId: string | null = null
let channel: BroadcastChannel | null = null

const isTicketUnreadInvalidation = (
  value: unknown,
): value is TicketUnreadInvalidation => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return false
  }

  const event = value as Record<string, unknown>
  return (
    event.type === 'ticket-unread-invalidated' &&
    typeof event.userId === 'string' &&
    typeof event.ticketId === 'string' &&
    (event.reason === 'read' || event.reason === 'closed')
  )
}

export const subscribeTicketUnreadInvalidations = (
  userId: string,
  onInvalidated: (event: TicketUnreadInvalidation) => void,
) => {
  channel?.close()
  activeUserId = userId
  channel =
    typeof BroadcastChannel === 'undefined'
      ? null
      : new BroadcastChannel(CHANNEL_NAME)

  const currentChannel = channel
  if (currentChannel) {
    currentChannel.onmessage = (message: MessageEvent<unknown>) => {
      if (
        activeUserId !== userId ||
        !isTicketUnreadInvalidation(message.data) ||
        message.data.userId !== userId
      ) {
        return
      }

      onInvalidated(message.data)
    }
  }

  return () => {
    if (activeUserId !== userId || channel !== currentChannel) {
      return
    }

    currentChannel?.close()
    channel = null
    activeUserId = null
  }
}

export const getActiveTicketUnreadUserId = () => activeUserId

export const publishTicketUnreadInvalidation = (
  event: TicketUnreadInvalidation,
) => {
  if (event.userId !== activeUserId || !channel) {
    return
  }

  channel.postMessage(event)
}
